import styled from 'styled-components';

import transparentBackground from '../../../../static/transparent-background.svg';
import style from '../../../style';
import type { Hex } from '../../../utils/types/colors/Hex';

interface IconWrapperProps {
  $color: Hex;
  $isLight: boolean;
  $isSelected?: boolean;
  $isClickable?: boolean;
}

export const TransparentBackground = styled.div(({ theme: { size } }) => ({
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  borderRadius: size.units(0.5),
  backgroundImage: `url("${transparentBackground}")`,
}));

export const StyledSwatch = styled.div(() => ({
  width: '100%',
  height: '100%',
}));

export const IconWrapper = styled.div<IconWrapperProps>(
  ({
    $isLight,
    $isSelected,
    $isClickable,
    $color: backgroundColor,
    theme: { color, size, transition },
  }) => ({
    backgroundColor,
    height: '100%',
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    cursor: $isSelected || !$isClickable ? 'default' : 'pointer',
    border: `1px solid ${color.border.tertiary.default(0.2)}`,
    borderRadius: size.units(0.5),
    transition: transition.standard('border'),

    ...style.mixins.devices.desktop({
      ':hover': {
        border:
          $isSelected || !$isClickable
            ? undefined
            : `2px solid ${color.border.tertiary.default(0.5)}`,
      },
      ':active': {
        border: $isSelected ? undefined : `1px solid ${color.border.tertiary.default(0)}`,
        transition: $isSelected ? undefined : 'border .1s cubic-bezier(.4,0,.4,1)',
      },
    }),

    svg: {
      width: size.units(2),
      fill: $isLight ? color.content.primary.default() : color.content.reversed.default(),
      transform: $isSelected ? 'scale(1)' : 'scale(0)',
      opacity: $isSelected ? 1 : 0,
      transition: $isSelected
        ? `${transition.standard()}, transform .2s cubic-bezier(.4,-0.7,.4,1.7)`
        : transition.standard(),
    },
  }),
);
